import { NgZone, Signal, signal } from '@angular/core';

const FALLBACK = '#385668';

/** Color de texto del tema. En oscuro es blanco; en claro, el gris de la interfaz. */
export function colorTextoGrafico(): string {
  if (typeof document === 'undefined') {
    return FALLBACK;
  }
  const value = getComputedStyle(document.documentElement).getPropertyValue('--p-text-color').trim();
  return value || FALLBACK;
}

export interface ColorTextoGrafico {
  readonly color: Signal<string>;
  destruir(): void;
}

export function vigilarColorTextoGrafico(zone: NgZone): ColorTextoGrafico {
  const color = signal(colorTextoGrafico());
  const observador = new MutationObserver(() => {
    const siguiente = colorTextoGrafico();
    if (siguiente !== color()) {
      zone.run(() => color.set(siguiente));
    }
  });
  observador.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  return {
    color,
    destruir: () => observador.disconnect(),
  };
}
